import Vue from 'vue'
import Vuex from 'vuex'
import * as fb from '../firebase'
import router from '../router/index'

Vue.use(Vuex)

// realtime firebase
fb.galleriesCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
  let galleriesArray = []

  snapshot.forEach(doc => {
    let gallery = doc.data()
    gallery.id = doc.id

    if (!gallery.deleted) {
      galleriesArray.push(gallery)
    }
    
  })

  store.commit('setGalleries', galleriesArray)
})


// fb.imagesCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//   let imagesArray = []

//   snapshot.forEach(doc => {
//     let image = doc.data()
//     image.id = doc.id

//     imagesArray.push(image)
//   })

//   store.commit('setImages', imagesArray)
// })

const store = new Vuex.Store({
  state: {
    userProfile: {},
    galleries: [],
    images: [],
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setPerformingRequest(state, val) {
      state.performingRequest = val
    },
    setGalleries(state, val) {
      state.galleries = val
    },
    setImages(state, val) {
      state.images = val
    }
  },
  actions: {
    async login({ dispatch }, form) {
      // sign user in
      const { user } = await fb.auth.signInWithEmailAndPassword(form.email, form.password)

      // console.log('login user', user)

      // fetch user profile and set in state
      dispatch('fetchUserProfile', user)
    },
    // async signup({ dispatch }, form) {
    //   // sign user up
    //   const { user } = await fb.auth.createUserWithEmailAndPassword(form.email, form.password)

    //   // create user object in userCollections
    //   await fb.usersCollection.doc(user.uid).set({
    //     name: form.name,
    //     title: form.title
    //   })

    //   // fetch user profile and set in state
    //   dispatch('fetchUserProfile', user)
    // },
    async fetchUserProfile({ commit }, user) {
      // fetch user profile
      const userProfile = await fb.usersCollection.doc(user.uid).get()

      
      // set user profile in state
      if (userProfile.exists) {
        commit('setUserProfile', userProfile.data())
      }
      else {
        await fb.usersCollection.doc(user.uid).set({
          uid: user.uid,
          name: user.email,
          role: ''
        })
      }
      

      // change route to dashboard
      if (router.currentRoute.path === '/login') {
        router.push('/')
      }
    },
    async logout({ commit }) {
      // log user out
      await fb.auth.signOut()

      // clear user data from state
      commit('setUserProfile', {})

      // redirect to login view
      router.push('/login')
    },
    async createGallery({ state, commit }, gallery) {
      // create post in firebase
      await fb.galleriesCollection.add({
        createdOn: new Date(),
        name: gallery.name,
        visible: true,
        detectText: true,
        detectColors: true,
        userId: fb.auth.currentUser.uid,
        numbersFrom: 0,
        numbersTo: 0,
        photos: 0,
        photos_detected: 0,
        validateNumbersToBuy: true
      })
    },

    async createImage({ state, commit }, image) {
      // create post in firebase
      // await fb.imagesCollection.add({
      //   createdOn: new Date(),
      //   name: image.name,
      //   //url: image.url,
      //   gs: image.gs,
      //   userId: fb.auth.currentUser.uid,
      //   galleryId: image.gallery,
      //   detectText: 'none'
      // })
    },

    // async likePost ({ commit }, post) {
    //   const userId = fb.auth.currentUser.uid
    //   const docId = `${userId}_${post.id}`

    //   // check if user has liked post
    //   const doc = await fb.likesCollection.doc(docId).get()
    //   if (doc.exists) { return }

    //   // create post
    //   await fb.likesCollection.doc(docId).set({
    //     postId: post.id,
    //     userId: userId
    //   })

    //   // update post likes count
    //   fb.postsCollection.doc(post.id).update({
    //     likes: post.likesCount + 1
    //   })
    // },
    async updateProfile({ dispatch }, user) {
      const userId = fb.auth.currentUser.uid
      // update user object
      const userRef = await fb.usersCollection.doc(userId).update({
        name: user.name,
        title: user.title
      })

      dispatch('fetchUserProfile', { uid: userId })

      // update all posts by user
      // const postDocs = await fb.postsCollection.where('userId', '==', userId).get()
      // postDocs.forEach(doc => {
      //   fb.postsCollection.doc(doc.id).update({
      //     userName: user.name
      //   })
      // })

      // // update all comments by user
      // const commentDocs = await fb.commentsCollection.where('userId', '==', userId).get()
      // commentDocs.forEach(doc => {
      //   fb.commentsCollection.doc(doc.id).update({
      //     userName: user.name
      //   })
      // })
    }
  }
})

export default store
